import { Text, View } from 'react-native';
import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import Constant from './tdsRedux/Constant';
import { backgroundTdsArr, backgroundTdsArrBackPage } from './backgroundTdsArr';
import getPlatformType from '../../helpers/getPlatform';
import { navigateAction } from '../../helpers/navigationHelpers';
import { Container, ButtonWrapper, Typography, BoxShadow } from './style';
import BackGroundGenerator from '../LandingPages/common/BackGroundGenerator';
import CustomTextInput from '../../commonComponents/customTextInput/customTextInput';
import { types } from '../../redux/actionTypes';
import { useRoute } from '@react-navigation/native';
import { tdsActions } from './tdsRedux/tds.actions';
import { ODSText } from '../../../openbrix-design-system/ui/atoms/ODSText';
import { useTheme } from '@emotion/react';
import { ODSIcon } from '../../../openbrix-design-system/ui/atoms/ODSIcon';
import ODSButton from '../../../openbrix-design-system/ui/atoms/ODSButton/index.native';
import { ODSInput } from '../../../openbrix-design-system/ui/atoms/ODSInput';
import { TouchableOpacity } from 'react-native';

const createPassword = (props) => {

  const dispatch = useDispatch();
  const { colors } = useTheme();
  const routes = useRoute();
  const layoutType = getPlatformType();
  const params = routes.params;
  const [secureTextEntry, setSecureTextEntry] = useState(true);

  const [type, setType] = useState('web');
  const [state, setState] = useState({
    password: '',
    rePassword: ''
  });

  useEffect(() => { }, []);

  const resendActivationLink = () => {
    window.open('https://www.tenancydepositscheme.com/forgotten-password/')
  }

  const handleChange = (value, field) => {
    setState({ ...state, [field]: value });
  };
  const handleOnChange = (value) => {
    setState({
      ...state,
      recaptchaValue: true,
      captchaToken: value
    });
  };

  const validatePassword = () => {
    let regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{10,}$/;
    if (regex.test(state?.password)) {
      if (state?.rePassword == state?.password) {
        if (state.captchaToken) {
          if (params) {
            let payload = {
              activation_code: params?.activation_code.trim(),
              email: params?.email.trim(),
              password: state?.password,
              password_confirm: state?.rePassword,
              captchaToken: state?.captchaToken
            }
            dispatch(tdsActions.resetPassword(payload, props?.navigation))
          }
          else {
            dispatch({
              type: types.SHOW_ALERT,
              alertType: "error",
              text: "Session Expired",
            });
          }
        } else {
          dispatch({
            type: types.SHOW_ALERT,
            alertType: "error",
            text: "Please validate recaptcha first!",
          });
        }

      }
      else {
        dispatch({
          type: types.SHOW_ALERT,
          alertType: "error",
          text: "Password not matched",
        });
      }
    }
    else {
      dispatch({
        type: types.SHOW_ALERT,
        alertType: "error",
        text: "Invalid password",
      });
    }
  }

  const renderBoxSection = () => {
    return (
      <View
        style={{
          width: layoutType != "web" ? '100%' : '70%',
          marginTop: 50,
          marginBottom: 50,
        }}
      >
        <BoxShadow bottom={'30px'} style={layoutType == 'phone' ? {} : { marginRight: 8, flex: 0.5 }}>

          <View style={{ width: '100%', borderRadius: 19, borderWidth: 2, borderColor: '#62D6A0', backgroundColor: '#DFFFF0', height: 90, justifyContent: 'center', alignItems: 'center' }}>
            <ODSText type='md-bold' color={colors.text.primary}>Please create a password</ODSText>
          </View>
          <ODSText marginTop={48} marginBottom={32} type='sm' color={colors.text.primary}>
            {`Your password must contain at least:

• one capital letter
• one lower case letter
• one number
• one special character from @$!%*?&£|^~#+=-
• minimum of 10 Characters or more

N.B - your password cannot contain any spaces`}
          </ODSText>

          <ODSInput
            placeholder='Password'
            type='password'
            label='Please enter your new password'
            secureTextEntry={secureTextEntry}
            onChange={(value) => handleChange(value, 'password')}
            renderRightIcon={
              <TouchableOpacity
                onPress={() => {
                  setSecureTextEntry(!secureTextEntry);
                }}
              >
                <ODSIcon icon={secureTextEntry ? 'eye-blocked' : 'eye'} size={20} />
              </TouchableOpacity>
            }
          />
          <ODSInput
            placeholder='Confirm Password'
            type='password'
            secureTextEntry={secureTextEntry}
            onChange={(value) => handleChange(value, 'rePassword')}
            renderRightIcon={
              <TouchableOpacity
                onPress={() => {
                  setSecureTextEntry(!secureTextEntry);
                }}
              >
                <ODSIcon icon={secureTextEntry ? 'eye-blocked' : 'eye'} size={20} />
              </TouchableOpacity>
            }
          />

          {/* <Typography top={'20px'} color={'#0000002'} size={'23px'} bottom={40} align={'flex-start'} bold={700}>
          Please enter your password
          </Typography>
          <CustomTextInput
            id="password"
            width={'100%'}
            placeHolder="Enter Password"
            type="password"
            name="password"
            // prefilledValue={state?.password}
            bColor={'#638ACC'}
            password
            renderRightComponent
            onChangeText={(value) => handleChange(value, 'password')}
          />
           <CustomTextInput
            id="rePassword"
            width={'100%'}
            placeHolder="Re-enter Password"
            type="password"
            name="rePassword"
            password
            renderRightComponent
            // prefilledValue={state?.rePassword}
            bColor={'#638ACC'}
            onChangeText={(value) => handleChange(value, 'rePassword')}
          /> */}
          <View
            style={{
              paddingVertical: "4%",

            }}
          >
            <ReCAPTCHA
              id={"register-recaptcha"}
              sitekey={Constant.RECAPTCHA_KEY}
              onChange={handleOnChange}
            />
          </View>
          <ODSButton
            restStyle={{ width: '60%', marginTop: 12, backgroundColor: '#FF41C0', height: 44, alignSelf: 'center' }}
            txtSize={16}
            onPress={() => validatePassword()}
          >
            Submit
          </ODSButton>
          {/* <ButtonWrapper
            width={'50%'}
            style={{ marginTop: 30 }}
            onPress={() =>validatePassword() }
          >
            <Typography color={'#FFFFFF'} size={'19px'} bold={700}>
            SUBMIT
            </Typography>
          </ButtonWrapper> */}
        </BoxShadow>
      </View>
    );
  };

  return (
    <>
      <BackGroundGenerator
        infoIcon
        isTds
        paddingtop={80}
        isBack={true}
        props={props}
        layoutType={(data) => {
          setType(data);
        }}
        isTLYF
        backgroundArr={backgroundTdsArrBackPage}
        backNavigation={() => navigateAction(props?.navigation, 'Custodial Activation')}
      >
        <Container
          width={"800px"}
        >
          {renderBoxSection()}

        </Container>
      </BackGroundGenerator>
    </>
  );
};

export default createPassword;
